import { FormControl } from 'baseui/form-control'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDButtonGroup from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/SDButtonGroup'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'

const ResidencePresence = () => {
  const { t, energyLandscape, updateAddressEnergyLandscape, errors, residenceType } = useAddress()

  if (residenceType !== 'main') {
    return null
  }

  return (
    <>
      <FormControl
        error={getError('occupancyFrequency', errors)}
        label={t('subscriptionTools:estimator.residence_presence_main.label')}
      >
        <SDButtonGroup
          onClickHandler={value => updateAddressEnergyLandscape({ residencePresence: value })}
          options={[
            { 0: t('subscriptionTools:estimator.residence_presence_main.all_day') },
            { 1: t('subscriptionTools:estimator.residence_presence_main.evening_weekend') },
          ]}
          selectedValue={energyLandscape?.residencePresence}
        />
      </FormControl>
    </>
  )
}

export default ResidencePresence
